// Set Defaults:
Cookies.defaults.domain = window.location.host.replace(/^localhost:\d+$/, "localhost");
Cookies.defaults.path = "/";
// Not sure if we need to allow any 3rd party sites to access cookies
//Cookies.defaults.sameSite = "strict";